export const startFeatures = instance => {
  instance.onReady().then(() => {
    instance.activate("emf213");
    instance.activate("emf212");
  });
};
